import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';
import progress from 'assets/icons/progress-icon.svg';
import info from 'assets/img/alert.svg';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useStoreSelector } from 'v3/data/store';
import { ContractingStateEnum } from 'v3/data/store/contracting/enums';
import { usePreferenceOptionActive } from 'v3/hooks/useIsPreferenceOptionActive';
import { IContractingDetailsParams } from 'v3/pages/Contracting/Details/Cards/types';
import { getContractingState } from 'v3/services/api';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import {
  Content,
  Icon,
  IconButtonStyled,
  IconStyled,
  InfoBox,
  PhoneIcon,
  RowStep,
  StyledDialog,
} from 'v3/shared/components/Modal/CafAnalysesModal/styles';
import { PreferencesOptionsEnum } from 'v3/shared/enums/preferences-options-enum';
import { BodyLarge } from 'v3/shared/typography/BodyLarge';
import { SubtitleLarge } from 'v3/shared/typography/SubtitleLarge';
import { TitleSmall } from 'v3/shared/typography/TitleSmall';

const NUMBER_SUPPORT_WHATSAPP = '551151920082';

export const CafAnalysisModal = () => {
  const { contractingKey } = useParams<Readonly<IContractingDetailsParams>>() as IContractingDetailsParams;
  const { contractingState } = useStoreSelector((store) => store.contracting);
  const isFlowDatasys = usePreferenceOptionActive(PreferencesOptionsEnum.IKCLOUD_40826_DATASYS_VOUCHER);

  const [cafModal, setCafModal] = useState(false);
  const theme = useTheme();
  const processingAntiFraud = contractingState === ContractingStateEnum.ProcessingAntiFraud;

  const openWhatsAppSupport = () => {
    window.open(`https://wa.me/${NUMBER_SUPPORT_WHATSAPP}`, '_blank');
  };

  useEffect(() => {
    setCafModal(
      (contractingState === ContractingStateEnum.CafRejected ||
        contractingState === ContractingStateEnum.ProcessingAntiFraud) &&
        isFlowDatasys,
    );
  }, [contractingState]);

  const handleRetry = async (contractingKey) => {
    const response = await getContractingState(contractingKey);
    if (response.data.status !== ContractingStateEnum.ProcessingAntiFraud) {
      setCafModal(false);
    }
  };

  return (
    <StyledDialog open={cafModal} onClose={() => setCafModal(false)}>
      <Content>
        {processingAntiFraud ? null : (
          <IconButtonStyled onClick={() => setCafModal(false)}>
            <CloseIcon />
          </IconButtonStyled>
        )}

        {processingAntiFraud ? <Icon src={progress} alt="Alert" /> : <Icon src={info} alt="Alert" />}

        {processingAntiFraud ? (
          <RowStep>
            <BodyLarge color={theme.palette.common.white} align="center">
              Estamos validando seus documentos
            </BodyLarge>
          </RowStep>
        ) : (
          <RowStep>
            <BodyLarge color={theme.palette.common.white} align="center">
              Não conseguimos finalizar sua solicitação
            </BodyLarge>
          </RowStep>
        )}

        {processingAntiFraud ? (
          <InfoBox>
            <IconStyled customColor={theme.palette.orange.light} />
            <TitleSmall color={theme.palette.orange.light}>Status da solicitação: Processando</TitleSmall>
          </InfoBox>
        ) : (
          <InfoBox>
            <IconStyled customColor={theme.palette.error.light} />
            <TitleSmall color={theme.palette.error.light}>Status da solicitação: CAF reprovada</TitleSmall>
          </InfoBox>
        )}

        {processingAntiFraud ? (
          <RowStep>
            <SubtitleLarge color={theme.palette.common.white} align="center">
              Por favor, aguarde alguns minutos e clique em tentar novamente
            </SubtitleLarge>
          </RowStep>
        ) : (
          <RowStep>
            <SubtitleLarge color={theme.palette.common.white} align="center">
              Entre em contato com a nossa central de atendimento para seguir com a contratação
            </SubtitleLarge>
          </RowStep>
        )}

        {processingAntiFraud ? (
          <FlexButton text="Tentar novamente" handleClick={() => handleRetry(contractingKey)} size="small" />
        ) : (
          <FlexButton text="Falar com a central" startIcon={PhoneIcon} handleClick={openWhatsAppSupport} />
        )}
      </Content>
    </StyledDialog>
  );
};
